import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Calendar from 'react-calendar/dist/entry.nostyle';

const CalendarFieldDatePicker = (props) => {
  const datePickerClasses = classNames(
    'datepicker',
    'dropdown-menu',
    {
      active: props.showCalendar,
    },
  );
  return (
    <div
      className={datePickerClasses}
      style={{
        top: '100%',
        display: props.showCalendar ? 'block' : 'none',
      }}
    >
      <Calendar
        maxDetail={props.maxDetail}
        calendarType="US"
        tileClassName="calendar-day"
        value={props.date}
        showFixedNumberOfWeeks={!props.isMobileOptimization}
        showNeighboringMonth={!props.isMobileOptimization}
        formatShortWeekday={props.getDayAbbreviation}
        formatMonth={value => value.toString().substring(4, 7)}
        onClickDay={props.onClickDay}
        onClickMonth={props.onClickMonth}
        nextLabel={props.getNextLabel()}
        prevLabel={props.getPrevLabel()}
      />
    </div>
  );
};

CalendarFieldDatePicker.defaultProps = {
  isMobileOptimization: false,
};

CalendarFieldDatePicker.propTypes = {
  date: PropTypes.instanceOf(Date).isRequired,
  getDayAbbreviation: PropTypes.func.isRequired,
  getNextLabel: PropTypes.func.isRequired,
  getPrevLabel: PropTypes.func.isRequired,
  isMobileOptimization: PropTypes.bool,
  maxDetail: PropTypes.oneOf(
    [
      'month',
      'year',
    ],
  ).isRequired,
  onClickDay: PropTypes.func.isRequired,
  onClickMonth: PropTypes.func.isRequired,
  showCalendar: PropTypes.bool.isRequired,
};

export default CalendarFieldDatePicker;



// WEBPACK FOOTER //
// ./src-react/StaticBuilder/CalendarField/CalendarFieldDatePicker.jsx